/**
 * Fait : un champ de saisie de plusieurs lignes — le frère de `Champ`, pour les
 *   textes qu'on écrit vraiment. Il porte son libellé, son aide et son erreur
 *   par les mêmes rattachements que lui.
 *
 * Ne fait pas : il ne valide rien, n'envoie rien, et ne décide pas de sa
 *   hauteur au-delà d'un minimum — c'est la personne qui l'étire si elle en a
 *   besoin.
 *
 * POURQUOI UN FRÈRE ET NON UNE OPTION DE `Champ` : `Champ` est employé par huit
 * fichiers et son contrat est celui d'un `input`. En changer le type pour un
 * seul besoin ferait payer les sept autres. Le dépôt fait déjà ce choix —
 * `ChampMotDePasse` est un frère, pas une option.
 *
 * POURQUOI IL EXISTE : le champ où l'on écrit son message faisait UNE ligne,
 * alors que c'est le geste central du produit. Retour de Charles, 2026-08-21.
 */

import type { TextareaHTMLAttributes } from 'react';
import { useId } from 'react';

export function ChampLong({
  libelle,
  aide,
  erreur,
  ...reste
}: {
  readonly libelle: string;
  readonly aide?: string;
  readonly erreur?: string;
} & TextareaHTMLAttributes<HTMLTextAreaElement>) {
  const identifiant = useId();
  const idAide = `${identifiant}-aide`;
  const idErreur = `${identifiant}-erreur`;

  const decrit = [aide === undefined ? '' : idAide, erreur === undefined ? '' : idErreur]
    .filter((x) => x !== '')
    .join(' ');

  return (
    <div className="champ">
      <label htmlFor={identifiant}>{libelle}</label>
      {aide !== undefined && (
        <p className="texte-attenue" id={idAide}>
          {aide}
        </p>
      )}
      <textarea
        id={identifiant}
        className="champ-long"
        aria-describedby={decrit === '' ? undefined : decrit}
        aria-invalid={erreur === undefined ? undefined : true}
        {...reste}
      />
      {erreur !== undefined && (
        <p className="message-erreur" id={idErreur}>
          {erreur}
        </p>
      )}
    </div>
  );
}
